import JobRightSidebarContainer from "../../../components/job/grid/JobRightSidebar";

const JobRightSidebar = () => {
  return <JobRightSidebarContainer />;
};

export default JobRightSidebar;
